import { UserAppLocationState, UserAppLocationStateI } from './../data/state/user-app-location.state';
import { ASetUserAppLocation } from './../data/actions/user-app-location.action';

import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, from, lastValueFrom, throwError } from 'rxjs';
import { AuthConnectProvider } from '../providers/account/auth-connect';
import * as Sentry from '@sentry/capacitor';

// Providers
import { UtilitiesProvider } from '../providers/utilities-provider';
import { Router } from '@angular/router';
import { tap, timeout } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';


@Injectable({
  providedIn: 'root',
})
export class AuthorizationInterceptor implements HttpInterceptor {
  userAppLocation: 'AUTH' | 'APP';
  @Select(UserAppLocationState.getUserAppLocation)
  userAppLocation$: Observable<UserAppLocationStateI>;
  constructor(
    private authConnect: AuthConnectProvider,
    private utilitiesProvider: UtilitiesProvider,
    private router: Router,
    private store: Store
  ) {
    this.userAppLocation$.subscribe((locationState) => (this.userAppLocation = locationState.userAppLocation));
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handleAccess(req, next));
  }

  private async handleAccess(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const isExpired = await this.authConnect.isExpired().then((res: boolean) => res);
    const isAuth = await this.authConnect.isAuthenticated().then((res: boolean) => res);
    const tokenType = localStorage.getItem('cognitoToken') || 'accessToken';
    const cognitoUser = await this.authConnect.getCognitoUserAsync();
    let token: string;

    if (!tokenType || !cognitoUser || tokenType === 'noToken') {
      //
    } else {
      // changes required from  back-end to always use id token for TL
      // even you see that condition bellow is always use idtoken
      // sometimes required it with bearer sometimes not
      token =
        tokenType === 'idToken'
          ? cognitoUser.cognitoUserSession.idToken
          : `bearer ${cognitoUser.cognitoUserSession.idToken}`;
    }
    /*
      Http Puts require an explicit content-type
      Differenitate contentent types for mimes / images requests here
    */
    //  debugger
    let headers: HttpRequest<any> = null;
    if (req?.method && req.method.toLowerCase() === 'get') {
      headers = req.clone({
        headers: req.headers.set('Authorization', `${token}`),
      });
    } else {
      headers = req.clone({
        headers: req.headers.set('Authorization', `${token}`).set('Content-Type', 'application/json'),
      });
    }
    // This is just for any call and assets
    if (this.userAppLocation === 'APP') {
      if (!cognitoUser || !isAuth) {
        this.sendUserToLogin();
      } else if (isExpired) {
        this.authConnect.refreshToken();
      }
    }

    if (
      (!cognitoUser || !isAuth || isExpired) &&
      tokenType === 'cognitoToken' &&
      !headers.url.includes('assets/i18n')
    ) {
      this.sendUserToLogin();
    } else {
      return lastValueFrom(next.handle(headers).pipe(timeout(45000), tap({ error: this.handleErrorMessage })));
    }
  }

  async handleErrorMessage(err: any) {
    if (!!err.name && err.name === 'TimeoutError') {
      await this.utilitiesProvider.presentToast('Timeout, please try again', '', { duration: 3000 });
    } else {
      switch (err.status) {
        case 200: {
          console.error('HTTP error:', err);
          break;
        }
        case 400:
        case 401:
        case 403:
        case 404:
        case 405:
        case 406:
        case 415: {
          await this.utilitiesProvider?.presentToast('An error has ocurred', '', { duration: 3000 });
          break;
        }
        case 500: {
          await this.utilitiesProvider?.presentToast('Error connecting to server', '', { duration: 3000 });
          break;
        }
        default: {
          await this.utilitiesProvider?.presentToast('An unforeseen error has ocurred', '', { duration: 3000 });
          break;
        }
      }
    }
    Sentry.captureException(err.message);
    return throwError(() => new Error(err.message));
  }

  private sendUserToLogin() {
    this.router.navigate(['login']);
    this.store.dispatch(new ASetUserAppLocation('AUTH'));
  }
}
